import { useNumericParams } from '@domain-group/react-hooks'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

import useReduxAction from '@hooks/useReduxAction'

import { ModuleState } from '@redux/modules/types'

import NotificationEditRoutes from './routes'

const NotificationEdit = () => {
  const { notificationId } = useNumericParams()

  useReduxAction(
    'notifications',
    'loadNotification',
    {
      entityId: notificationId,
      ...defaultRequestOptions.notification,
    },
    [notificationId],
    {
      dispatchAction: (action, requestOptions) => action(notificationId, requestOptions),
      // @ts-expect-error TS2322
      shouldPerformFn: ({ loading }: ModuleState) => notificationId && !loading,
    },
  )

  return (
    <NotificationEditRoutes notificationId={notificationId} />
  )
}

export default NotificationEdit
